import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { OrderFlowStep, OrderFlowStepState } from './order-flow-steps.types';

interface OrderFlowStepView {
  key: OrderFlowStep;
  state: OrderFlowStepState;
  iconName: string;
}

// Cart -> Address -> Payment progress indicator: steps before activeStep are completed, after are pending.
@Component({
  selector: 'app-order-flow-steps',
  templateUrl: './order-flow-steps.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CsIconModule],
})
export class OrderFlowStepsComponent {
  activeStep = input<OrderFlowStep>(OrderFlowStep.CART);

  protected readonly OrderFlowStep = OrderFlowStep;
  protected readonly OrderFlowStepState = OrderFlowStepState;

  private readonly order: OrderFlowStep[] = [OrderFlowStep.CART, OrderFlowStep.ADDRESS, OrderFlowStep.PAYMENT];

  protected readonly steps = computed<OrderFlowStepView[]>(() => {
    const activeIndex = this.order.indexOf(this.activeStep());
    return this.order.map((key: OrderFlowStep, index: number): OrderFlowStepView => {
      const state: OrderFlowStepState = index < activeIndex
        ? OrderFlowStepState.COMPLETED
        : index === activeIndex ? OrderFlowStepState.ACTIVE : OrderFlowStepState.PENDING;
      const iconName = state === OrderFlowStepState.COMPLETED
        ? 'step_completed'
        : state === OrderFlowStepState.ACTIVE ? 'radio_button_checked' : 'radio_button_dot';
      return { key, state, iconName };
    });
  });
}
